import {
    productLinks,
    surveyLinks,
    hashtagLinks,
    collaborationInternalLinks,
    polling,
    quizLinks,
    workshopLinks,
    certificateLinks,
    palateDiscoveryLinks,
} from "../../utils/internalLinks";

export const quickLinks = {
    collaborate: collaborationInternalLinks.all,
    "product-review": collaborationInternalLinks.productReviews,
    product: productLinks.all,
    polling: polling.all,
    surveys: surveyLinks.all,
    hashtag: hashtagLinks.trending,
    quiz: quizLinks.all,
    workshop: workshopLinks.all,
    certification: certificateLinks.all,
    "palate-discovery": (id) => palateDiscoveryLinks.test(id),
}